import React, { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import useSize from '@react-hook/size';
import Footer from './footer';
import { updateAppBarsOffset } from '../ducks/app';
import { isAuthRequired } from '../lib/settings';
import { getIsFull } from '../selectors';
import Page from './Page';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from '../i18n/index';
import AppBars from './AppBars';
import { useOidc } from '../hooks/useOidc.js';
import { useLocation } from 'react-router';
import { ROUTE_VIEWER } from '../constants.js';
import { ID_FOOTER } from '../css-api';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
  },
  content: {
    flexGrow: 1,
  },
  footerContainer: {
    zIndex: 0,
  },
  wrapper: {
    padding: theme.spacing(8),
  },
}));

const Component = ({ children }) => {
  const classes = useStyles();
  const isFull = useSelector(getIsFull);
  const { pathname } = useLocation();
  const isViewer = pathname === ROUTE_VIEWER;
  const hasHF = !isFull && !isViewer;
  const { login, user } = useOidc();

  const dispatch = useDispatch();
  const appBarsRef = useRef(null);
  const [, appBarsHeight] = useSize(appBarsRef);

  useEffect(() => {
    const height = appBarsRef.current?.getBoundingClientRect().height ?? 0;
    dispatch(updateAppBarsOffset(height));
  }, [appBarsHeight, isFull]);

  return (
    <Grid container wrap="nowrap" direction="column" className={classes.root}>
      {hasHF && (
        <Grid item>
          <AppBars ref={appBarsRef} />
        </Grid>
      )}
      {!isAuthRequired || (isAuthRequired && user) ? (
        children
      ) : (
        <Page id="authRequired">
          <Grid container direction="column" className={classes.wrapper}>
            <Grid item container justifyContent="center">
              <Typography variant="h6" align="center">
                <FormattedMessage id="auth.required" />
              </Typography>
            </Grid>
            <Grid item container justifyContent="center">
              <Button onClick={() => login()} variant="outlined" color="primary">
                <FormattedMessage id="user.login" />
              </Button>
            </Grid>
          </Grid>
        </Page>
      )}
      {hasHF && (
        <Grid item id={ID_FOOTER} className={classes.footerContainer}>
          <Footer />
        </Grid>
      )}
    </Grid>
  );
};

export default Component;
